// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"drink"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M7.15156 21.9997H17.9229L18.5 13.5459L12.1594 12.4936L6.4375 11.5635L7.15156 21.9997Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M3 6.22233C3 7.97123 4.5 9.38088 6.28912 9.38088L6.07443 6.22233H9.46279C9.46279 4.47343 8.01604 3.05566 6.23139 3.05566C4.44674 3.05566 3 4.47343 3 6.22233Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M3 6.22233C3 7.97123 4.5 9.38088 6.28912 9.38088L6.07443 6.22233H9.46279C9.46279 4.47343 8.01604 3.05566 6.23139 3.05566C4.44674 3.05566 3 4.47343 3 6.22233Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M19.0001 2H15.2301L12.5 12M6.07422 6.22266H18.9998L17.9227 22.0004H7.15135L6.07422 6.22266ZM17.9229 21.9997H7.15156L6.4375 11.5635L12.1594 12.4936L18.5 13.5459L17.9229 21.9997Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const DrinkIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'drink',
    ref,
    icon: element,
  },
));

DrinkIcon.displayName = 'DrinkIcon';

export default DrinkIcon;
